export enum SourceType {
AADE,
ERP,
LOCAL,
}
